export const selfAppsSelector = (state) => state.push.apps;